import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/listing/actionTypes';

import { saveDraft } from './utils';

export default function* listenSave() {
  yield takeEvery(actionTypes.SAVE_DRAFT, saveDraft);
}
